import axios from "axios";

const resources_sidebar_el = document.querySelector('.resources-sidebar');
const resources_posts_el = document.querySelector('#resources_posts');
const showing_text_el = document.querySelector('#showing_text');
const showing_text_value_el = document.querySelector('[name="showing_text_value"]');
const search_el = document.querySelector('[name="s"]');
const sorting_select_el = document.querySelector('.sorting_select');

const resource_search_el = document.querySelector('.resource-search');
const resource_search_row_el = document.querySelector('.resource-search__row');

/**
 * Shared function to apply filters and sorting
 * @param {number} page - Page number to fetch (default: 1)
 */
const applyFiltersAndSorting = async (page = 1) => {
    // Add loading state
    resources_posts_el.classList.add('loading');
    
    const filterParams = {};
    const filterData = {};

    document.querySelectorAll('.resources-sidebar [name^="filter["]').forEach(input => {
        const nameMatch = input.name.match(/filter\[(.+?)\]/);
        if (!nameMatch) return;

        const taxonomy = nameMatch[1];
        const value = input.value;

        if (input.type === 'checkbox') {
            if (!filterData[taxonomy]) {
                filterData[taxonomy] = [];
            }
            if (input.checked) {
                filterData[taxonomy].push(value);
            }
        } else if (input.type === 'radio') {
            if (input.checked) {
                filterData[taxonomy] = value;
            }
        }
    });

    filterParams['filterData'] = filterData;

    if (search_el && search_el.value.trim() !== '') {
        filterParams.s = search_el.value.trim();
    }

    if (sorting_select_el) {
        filterParams.sort = sorting_select_el.value;
    }

    filterParams.paged = page;

    const filtered_data = await getFilteredData(filterParams);

    if (filtered_data.success) {
        resources_posts_el.innerHTML = filtered_data.data.html;

        const from_text = filtered_data.data.from || 0;
        const to = filtered_data.data.to || 0;
        const total = filtered_data.data.total || 0;

        showing_text_el.innerHTML = showing_text_value_el.value
            .split('%s')
            .reduce((acc, part, i) => acc + part + (i < 3 ? [from_text, to, total][i] : ''), '');

        // Rebind pagination click handlers
        bindPaginationHandlers();
    }
    
    // Remove loading state
    resources_posts_el.classList.remove('loading');
};

/**
 * Bind click handlers to AJAX pagination links
 */
const bindPaginationHandlers = () => {
    document.querySelectorAll('.ajax-pagination').forEach(link => {
        link.addEventListener('click', async (e) => {
            e.preventDefault();
            const page = parseInt(link.dataset.page, 10);
            await applyFiltersAndSorting(page);
            // Scroll to top of resources
            resources_posts_el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });
};

// Auto-apply filters when any filter checkbox/radio changes (reset to page 1)
document.querySelectorAll('.resources-sidebar [name^="filter["]').forEach(input => {
    input.addEventListener('change', () => applyFiltersAndSorting(1));
});

// Auto-apply when sorting changes (reset to page 1)
sorting_select_el?.addEventListener('change', () => applyFiltersAndSorting(1));

// Bind pagination handlers on initial page load
bindPaginationHandlers();

const debounce = (fn, delay = 300) => {
    let timeoutId;

    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};

document.querySelector('.resource-search__breadcrumbs')?.addEventListener('click', function () {
    resource_search_el.classList.remove('active');
    resource_search_row_el.innerHTML = '';
});

search_el?.addEventListener('input', debounce(async function () {
    const searchValue = this.value;

    axios.get(font_api_settings.ajax_url, {
        params: {
            nonce: font_api_settings.nonce,
            action: 'search_resources',
            s: searchValue,
        }
    })
        .then(function (response) {
            const data = response.data.data;
            let html_search = `<div class="resource-search-item">Nothing found</div>`;

            if (response.data.success && data.posts_array.length > 0) {
                html_search = data.html;
            }

            resource_search_row_el.innerHTML = html_search;
            resource_search_el.classList.add('active');
        })
        .catch(function (error) {
            console.log(error);
        });
}, 500));

// Apply filters button (optional, since filters auto-apply now)
document.querySelector('.btn_filter_apply')?.addEventListener('click', async function () {
    const _el = this;
    _el.setAttribute('disabled', 'true');
    await applyFiltersAndSorting();
    _el.removeAttribute('disabled');
});

document.querySelector('.btn_filter_clear')?.addEventListener('click', async function () {
    const _el = this;
    _el.setAttribute('disabled', 'true');

    const showing_text_value_text = showing_text_value_el.value;

    resources_sidebar_el.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.checked = false;
    });

    resources_sidebar_el.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = false;
    });

    search_el.value = '';
    sorting_select_el.value = 'newest';

    const filtered_data = await getFilteredData({});
    updateURLParams({
        filterData: null,
        s: null,
        sort: null
    }, true);
    
    localStorage.removeItem('filesPageLastUrl');

    if (filtered_data.success) {
        console.log(filtered_data.data);
        resources_posts_el.innerHTML = filtered_data.data.html;

        const from_text = filtered_data.data.from || 0;
        const to   = filtered_data.data.to || 0;
        const total = filtered_data.data.total || 0;

        showing_text_el.innerHTML = showing_text_value_text
            .split('%s')
            .reduce((acc, part, i) => acc + part + (i < 3 ? [from_text, to, total][i] : ''), '');
    }
    else {
        console.log(filtered_data);
    }

    _el.removeAttribute('disabled');
});

const getFilteredData = async (filterParams) => {
    updateURLParams(filterParams, true);
    saveFiltersToLocalStorage(); // Зберегти URL після оновлення параметрів

    return await axios.get(font_api_settings.ajax_url, {
        params: {
            nonce: font_api_settings.nonce,
            action: 'filter_resources',
            filterData: filterParams.filterData,
            s: filterParams.s,
            sort: filterParams.sort,
            per_page: 9,
            paged: filterParams.paged || 1,
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
};

const updateURLParams = (params = {}, replaceState = true) => {
    const url = new URL(window.location.href);

    Object.keys(params).forEach(key => {
        const value = params[key];

        if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
            url.searchParams.delete(key);
        } else if (Array.isArray(value) || typeof value === 'object') {
            // Сериализуем массивы и объекты в JSON
            url.searchParams.set(key, encodeURIComponent(JSON.stringify(value)));
        } else {
            url.searchParams.set(key, value);
        }
    });

    if (replaceState) {
        window.history.replaceState({}, '', url.toString());
    } else {
        window.location.href = url.toString();
    }

    return url.toString();
};

/**
 * Save current filters URL to localStorage
 */
const saveFiltersToLocalStorage = () => {
    const currentUrl = window.location.pathname + window.location.search;
    
    // Зберігаємо тільки якщо є параметри фільтрації
    if (window.location.search && 
        (window.location.search.includes('filterData') || 
         window.location.search.includes('sort') || 
         window.location.search.includes('paged'))) {
        localStorage.setItem('filesPageLastUrl', currentUrl);
    }
};

/**
 * Initialize filters tracking on page load
 */
const initFiltersTracking = () => {
    // Перевіряємо чи ми на сторінці /files/
    if (window.location.pathname.includes('/files/') && 
        !window.location.pathname.match(/\/files\/[^\/]+\//)) {
        saveFiltersToLocalStorage();
    }
};

// Викликати при завантаженні сторінки
document.addEventListener('DOMContentLoaded', initFiltersTracking);
